export const ru = {
    any: 'Любой',
    common: 'Общий',
    coupe: 'Купе',
    lux: 'СВ',
    reserved: 'Плацкарт',
    seat: 'Сидячий',
    vip: 'Люкс',
};
